export default __webpack_public_path__ + "static/media/blackbird3.7b0259f5.jpg";